export default "__VITE_ASSET__ZwPaiVX___"